import { FC, useEffect, useState } from 'react';
import { NudosButton, NudosTextInput } from '../../../../../../../components/NudosComponents';
import { IAdditionalTax, IPaymentData, IUpdateTaxInfo } from '../../../../../../../types/orders';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../../utils/displayNudosStandardNotifications';
import { updateAdditionalTaxInfo } from '../../../../../../../services/orders';

import './AdditionalTaxComponent.scss';

interface IAdditionalTaxComponent {
  showComponent: boolean;
  orderId: number;
  updateWithLoaders?: () => void;
  paymentData?: IPaymentData;
  disabledComponent: boolean;
  currencyCode?: string;
}

const AdditionalTaxComponent: FC<IAdditionalTaxComponent> = ({
  showComponent,
  orderId,
  updateWithLoaders,
  paymentData,
  disabledComponent,
  currencyCode
}: IAdditionalTaxComponent) => {
  const [additionalTax, setAdditionalTax] = useState<IAdditionalTax>();
  const [wasEdited, setWasEdited] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);

  const initialData = () => {
    if (paymentData) {
      const otherExpenses =
        paymentData?.otherExpenses.length > 0
          ? paymentData?.otherExpenses[paymentData?.otherExpenses?.length - 1]
          : undefined;

      const initialData: IAdditionalTax = {
        iva: paymentData?.taxValueUsd,
        conceptOfOthers: otherExpenses?.concept || '',
        exchangeRate: String(paymentData?.exchangeRate || ''),
        others: String(otherExpenses?.valueUsd || '')
      };
      setAdditionalTax({ ...initialData });
    }
  };

  const updateAdditionalTax = async () => {
    setLoadingData(true);
    try {
      if (updateWithLoaders) {
        const bodyUpdateData: IUpdateTaxInfo = {
          exchangeRate: Number(additionalTax?.exchangeRate),
          subtotalTaxValueUsd: Number(additionalTax?.iva),
          other: [
            {
              concept: additionalTax?.conceptOfOthers || '',
              orderPriceId: Number(paymentData?.orderPriceId),
              valueUsd: Number(additionalTax?.others)
            }
          ]
        };
        await updateAdditionalTaxInfo(orderId, bodyUpdateData);
        await updateWithLoaders();
        displaySuccessNotification({ customJSXMessage: <>Datos Actualizados con éxito </> });
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);

  return (
    <>
      {showComponent && (
        <div id="additionalTaxComponent">
          <NudosTextInput
            componentSize="extraSmall"
            label="IVA USD"
            isFilled={!!additionalTax?.iva}
            placeholder="USD"
            defaultValue={String(additionalTax?.iva || '')}
            handleChange={e => {
              setAdditionalTax({ ...additionalTax, ...{ iva: e } });
              setWasEdited(true);
            }}
            isDeactivated={disabledComponent}
          />
          <NudosTextInput
            componentSize="extraSmall"
            label="Tipo de cambio"
            isFilled={!!additionalTax?.exchangeRate}
            placeholder={currencyCode || 'ARG'}
            defaultValue={additionalTax?.exchangeRate}
            handleChange={e => {
              setAdditionalTax({ ...additionalTax, ...{ exchangeRate: e } });
              setWasEdited(true);
            }}
            isDeactivated={disabledComponent}
          />
          <NudosTextInput
            styleLabel="whitespace-nowrap"
            componentSize="extraSmall"
            label="Otros USD (opcional)"
            isFilled={!!additionalTax?.others}
            defaultValue={additionalTax?.others}
            placeholder="USD"
            handleChange={e => {
              setAdditionalTax({ ...additionalTax, ...{ others: e } });
              setWasEdited(true);
            }}
            isDeactivated={disabledComponent}
          />
          <NudosTextInput
            componentSize="small"
            label="Concepto de otros (opcional)"
            isFilled={!!additionalTax?.conceptOfOthers}
            defaultValue={additionalTax?.conceptOfOthers}
            placeholder="Ingresa el concepto del monto"
            handleChange={e => {
              setAdditionalTax({ ...additionalTax, ...{ conceptOfOthers: e } });
              setWasEdited(true);
            }}
            isDeactivated={disabledComponent}
          />
          <div className="bottonButtonContainer">
            <NudosButton
              isButtonLoading={loadingData}
              isButtonDisabled={!wasEdited || !additionalTax?.iva || !additionalTax?.exchangeRate || disabledComponent}
              customHeight="18px"
              customWidth="80px"
              customClassName="saveButton"
              buttonText="Guardar"
              handleClick={() => {
                updateAdditionalTax();
              }}
            />
          </div>
        </div>
      )}{' '}
    </>
  );
};

export default AdditionalTaxComponent;
